import classNames from 'classnames';
import { BodyText, Button, Headline, IconV2, LayoutBox } from '@bamboohr/fabric';
import { isEnabled } from '@bamboohr/utils/lib/feature';
import { TextDivider } from '../../../../login/login/components/text-divider';
import { bem } from '../../constants';

export function LoginForm(props) {
	const {
		children,
		headerText,
		instructionText,
		isPasskeyUser,
		primaryAction,
		userId,
		username,
	} = props;

	const formClasses = classNames(
		bem.className(),
		'BhrForms',
		'js-lockScreenForm',
	);

	return (
		<form
			className={ formClasses }
			onKeyDown={ (e) => {
				if (e.key === 'Escape') {
					e.stopPropagation();
				}
			} }
			onSubmit={ e => e.preventDefault() }
			tabIndex="-1"
		>
			<LayoutBox marginBottom={1}>
				<Headline color="neutral-strong" size="small">{ headerText }</Headline>
			</LayoutBox>
			<LayoutBox marginBottom={3}>
				<BodyText color="neutral-extra-strong" justify="center">
					{ instructionText }
				</BodyText>
			</LayoutBox>
			{ children }
			<LayoutBox marginBottom={6.5}>
				{ isEnabled('PASSKEYS') && isPasskeyUser ? (
					<>
						<TextDivider text={$.__('OR')} />
						<Button
							onClick={() => primaryAction(true)}
							startIcon={<IconV2 name="keypass-regular" size={16}/>}
							variant="outlined"
							width={9}
						>
							{$.__('Log in with a Passkey')}
						</Button>
					</>
				) : null}
			</LayoutBox>
			<input type="hidden" id="userid" name="userid" value={ userId } />
			<input type="hidden" id="username" name="username" value={ username } />
		</form>
    );
}
